import { render } from "./TemplateLeft.vue?vue&type=template&id=53af8dd8&scoped=true"
import script from "./TemplateLeft.vue?vue&type=script&lang=js"
export * from "./TemplateLeft.vue?vue&type=script&lang=js"

import "./TemplateLeft.vue?vue&type=style&index=0&id=53af8dd8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53af8dd8"]])

export default __exports__